import React from "react";
import Header from "@/components/Header";
import InventoryDashboard from "@/components/InventoryDashboard";
import SEO from "@/components/SEO";
import AlertsAuthGuard from "@/components/alerts/AlertsAuthGuard";
import SubscriptionBanner from "@/components/subscription/SubscriptionBanner";

const ProductSearchPage = () => {
  return (
    <AlertsAuthGuard>
      <SEO
        title="Product Search - Utah Whiskey Tracker"
        description="Search the current Utah DABS inventory in real-time. Find available whiskey, bourbon, and spirits across all Utah state liquor stores."
        keywords="product search, utah DABS inventory, real-time search, whiskey search, bourbon availability, utah liquor stores"
        canonical="https://utahwhiskeytracker.com/product-search"
      />
      <div className="min-h-screen bg-gradient-to-br from-whiskey-light to-background">
        <Header />
        <SubscriptionBanner />
        <div className="container mx-auto p-4">
          <div className="max-w-4xl mx-auto text-center mb-12 pt-4">
            <h1 className="text-3xl md:text-5xl font-bold mb-4 text-whiskey-dark">
              Product Search
            </h1>
            <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto">
              Search the current Utah DABS inventory in real-time to see what's available right now.
            </p>
          </div>
          
          <div className="max-w-4xl mx-auto">
            <div className="bg-white border border-[#FFB347] rounded-xl p-6">
              <InventoryDashboard />
            </div>
          </div>
        </div>
      </div>
    </AlertsAuthGuard>
  );
};

export default ProductSearchPage;